import { Component } from "react";

import "react-datepicker/dist/react-datepicker.css";

import PayementBCCheque from "./PayementBCCheque";
import PayementBCEnLigne from "./PayementBCEnLigne";
import PayementBCEspece from "./PayementBCEspece";
import PayementBCVirement from "./PayementBCVirement";

class MethodePayementBC extends Component {
  state = {
    methodePayement: "",
  };

  constructor(props) {
    super(props);
    this.state = {
      methodePayement: "",
    };
  }

  createUIPayement() {
    if (this.state.methodePayement === "CHEQUE") {
      return <PayementBCCheque  />;
    } else if (this.state.methodePayement === "ENLIGNE") {
      return <PayementBCEnLigne  />;
    } else if (this.state.methodePayement === "ESPECE") {
      return <PayementBCEspece  />;
    } else if (this.state.methodePayement === "VIREMENT") {
      return <PayementBCVirement />;
    }
  }

  handleChangePayement = (e) => {
    let payement = e.target.value;
    this.setState({
      methodePayement: payement,
    });
  };

  render() {
    return (
      <div className="card-body">
        <h5 className="card-title">Choisir le mode de payement </h5>
        <div class="row">
          <div class="col-2"></div>
          <div class="col-10">
            <select class="form-control" onChange={this.handleChangePayement}>
              <option key={0} value={0}>
                Sélectionner un mode de payement
              </option>
              <option key={1} value={"ESPECE"}>
                Espèce
              </option>
              <option key={2} value={"ENLIGNE"}>
                En ligne
              </option>
              <option key={3} value={"CHEQUE"}>
                Chèques / Traites
              </option>
              <option key={4} value={"VIREMENT"}>
                Virement
              </option>
            </select>
          </div>
        </div>
        {this.createUIPayement()}
        <br />
        <br />
      </div>
    );
  }
}
export default MethodePayementBC;
